var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    {
      staticClass: "m-0 px-8 pt-6",
      attrs: { id: "projects-wrapper", fluid: "" },
    },
    [
      _c(
        "v-col",
        {
          staticClass: "pa-0 ma-0 d-flex align-center",
          attrs: { cols: "2", fluid: "" },
        },
        [
          _c("h3", {
            staticClass: "text-h3",
            staticStyle: { color: "var(--v-text-base)" },
            attrs: { id: "title-page-1" },
            domProps: {
              textContent: _vm._s(_vm.$t("projects-filter-list.title")),
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "v-container",
        {
          staticClass:
            "d-flex projects-tip justify-space-between align-items-center mx-0 mb-0 pl-0 pt-0",
          attrs: { fluid: "", "data-cy": "projects-tip-container" },
        },
        [
          _c("span", {
            staticClass: "text-subtitle-3 mt-1",
            attrs: { "data-cy": "projects-tip-text" },
            domProps: {
              textContent: _vm._s(_vm.$t("projects-filter-list.tip")),
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-4" },
        [
          _c("ProjectsFilter", {
            attrs: {
              projects: _vm.projects,
              onCompanyChange: _vm.handleCompanyChange,
              onSearch: _vm.handleSearchChange,
              companies: _vm.companies,
            },
          }),
          _vm._v(" "),
          _c("ProjectsList", {
            attrs: {
              projects: _vm.filteredProjects,
              displaySkeleton: _vm.displaySkeleton,
              companies: _vm.companies,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }